<template>
  <VContainer class="flex items-center justify-center h-full">
    <VCard
      :class="[locale === 'de' ? 'max-w-[576px]' : 'max-w-[467px]', 'flex flex-col p-8 gap-6']"
    >
      <VCardTitle class="p-0">
        <div class="border !rounded-xl p-4">
          <div class="flex gap-4 items-center text-grey-600">
            <div class="border p-2 rounded-lg flex items-center justify-center">
              <VIcon
                class="material-icons-outlined"
                icon="information_outline"
                size="20"
                color="grey-700"
              />
            </div>

            <p class="text-sm text-wrap tracking-normal">
              {{
                t(
                  'Your selection is required for the correct assignment of requests from consultations and emergency calls'
                )
              }}
            </p>
          </div>
        </div>
      </VCardTitle>

      <VCardItem class="p-0">
        <h4 class="text-h4">{{ userStore.getDisplayName }},</h4>

        <ShiftManager
          :compact-mode="false"
          :shift-selection-title="`${t('Select shift')}.`"
          :submit-button-text="t('Continue')"
          :breakpoint="'sm'"
        >
          <template #additional-actions>
            <VBtn
              data-testid="logout-btn"
              class="font-semibold py-2 px-5 text-[15px] leading-[26px] flex h-auto"
              :color="'primary'"
              :variant="'outlined'"
              :text="t('Logout')"
              @click="onLogout"
            />
          </template>
        </ShiftManager>
      </VCardItem>
    </VCard>
  </VContainer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import { NoticeType } from '@/stores/models/Notice'
import { useNoticeStore } from '@/stores/notice'
import { AuthenticationService } from '@/services/AuthenticationService'
import ShiftManager from '@/components/shift/ShiftManager.vue'

const { t, locale } = useI18n()
const noticeStore = useNoticeStore()
const userStore = useUserStore()

async function onLogout() {
  try {
    await AuthenticationService.logout()
  } catch (e) {
    console.error(e)
    noticeStore.add({
      type: NoticeType.ERROR,
      message: t('Failed to logout')
    })
  }
}
</script>

<style scoped></style>
